const mutations = {
    setMyCompanyMocker(state,payload){
        state.me.company = payload
    },
    setMe(state,payload){
        let user =  checkUserRole(payload)
        state.me =user
    },
    setUsers(state,payload) {
        state.users = payload
    }
}

export default mutations